export default class ReadOnlyTableController {
  getBlockColorClass (color = 'default') {
    return `${color}-block`
  }
}
